// removed by extract-text-webpack-plugin
module.exports = {"LicenseInfo__Container":"zaMxi8XqoeD28ulWynXXr","LicenseInfo__Container-inner":"_1F4RmWLL3yEmW5dqrn013l"};


//////////////////
// WEBPACK FOOTER
// ./src/components/LicenseInfoDialog/LicenseInfoDialog.scss
// module id = 2726
// module chunks = 0